
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Icon } from "vant";
import { generateWechatQrcode, pollWechatQrcodeStatus } from "@/request/wechat";
import { generateUUID } from "@/utils/uuid";

@Component({
  components: {
    [Icon.name]: Icon,
  },
})
export default class WechatLogin extends Vue {
  private qrcodeUrl: string = "";
  private isLoggedIn: boolean = false;
  private checkLoginTimer: any = null;
  private sceneStr: string = "";
  private loginTimeout: any = null;
  private pollTimer: any = null;
  private pollErrorCount: number = 0;
  private readonly MAX_POLL_ERROR = 3;
  private readonly LOGIN_TIMEOUT = 5 * 60 * 1000; // 5分钟超时
  private readonly CHECK_INTERVAL = 2000; // 2秒检查一次
  private errorMessage: string = "";

  private async created() {
    await this.getQrcode();
  }

  private async getQrcode() {
    let loading: any = null;
    try {
      loading = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 生成UUID作为scene_str
      this.sceneStr = generateUUID();
      // 调用新的二维码生成接口
      const res = await generateWechatQrcode(this, this.sceneStr, loading);
      this.qrcodeUrl = res.qrcode_url;
      this.errorMessage = "";
      this.startPollingStatus();
      this.startLoginTimeout();
    } catch (error) {
      this.errorMessage = "获取二维码失败，请重试";
      this.$toast.fail(this.errorMessage);
    } finally {
      // 无论成功失败都关闭 loading
      if (loading && loading.clear) loading.clear();
      // 兼容 Vant 3.x Toast.clear()
      // import('vant').then(({ Toast }) => { Toast.clear(); });
    }
  }

  private startPollingStatus() {
    if (this.pollTimer) clearInterval(this.pollTimer);
    this.pollErrorCount = 0; // 每次开始轮询时重置
    this.pollTimer = setInterval(async () => {
      try {
        const res = await pollWechatQrcodeStatus(this.sceneStr);
        this.pollErrorCount = 0; // 只要成功就清零
        // 判断第一个结果的access_token为object且不为null
        if (
          Array.isArray(res) &&
          res.length > 0 &&
          res[0].access_token &&
          typeof res[0].access_token === "object"
        ) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
          this.handleLoginSuccess(res[0]);
        }
      } catch (e) {
        this.pollErrorCount++;
        if (this.pollErrorCount >= this.MAX_POLL_ERROR) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
          this.errorMessage = "网络异常，请刷新二维码重试";
          this.$toast.fail(this.errorMessage);
        }
      }
    }, this.CHECK_INTERVAL);
  }

  private startLoginTimeout() {
    this.loginTimeout = setTimeout(() => {
      this.handleLoginTimeout();
    }, this.LOGIN_TIMEOUT);
  }

  private handleLoginSuccess(res: any) {
    // 后端返回的是 user 字段，不是 user_id
    const { access_token, user } = res;
    this.$store.commit("setUserInfo", res.access_token);
    localStorage.setItem("isLoggedIn", "true");
    this.isLoggedIn = true;
    this.stopCheckLogin();
    this.clearLoginTimeout();
    this.$toast.success("登录成功");
    setTimeout(() => {
      console.log("登录成功");
      // 通知父组件弹出基本信息弹框
      this.$emit("showBasicInfo");
      this.closeModal();
    }, 1500);
  }

  private handleLoginTimeout() {
    this.stopCheckLogin();
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
    this.errorMessage = "登录超时，请重新扫码";
    this.$toast.fail(this.errorMessage);
    this.refreshQrcode();
  }

  private async refreshQrcode() {
    this.qrcodeUrl = "";
    this.sceneStr = "";
    this.isLoggedIn = false;
    this.errorMessage = "";
    this.stopCheckLogin();
    this.clearLoginTimeout();
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
    await this.getQrcode();
  }

  private stopCheckLogin() {
    if (this.checkLoginTimer) {
      clearInterval(this.checkLoginTimer);
      this.checkLoginTimer = null;
    }
  }

  private clearLoginTimeout() {
    if (this.loginTimeout) {
      clearTimeout(this.loginTimeout);
      this.loginTimeout = null;
    }
  }

  @Emit("close")
  private closeModal() {
    console.log("关闭");
    this.stopCheckLogin();
    this.clearLoginTimeout();
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }

  beforeDestroy() {
    this.stopCheckLogin();
    this.clearLoginTimeout();
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }
}
